import React, { useState, useContext, useEffect } from 'react';
import { Slider } from '@mui/material';
import { MapContext } from '../MapContext';

const opacityProperty = {
  'gene': 'circle-opacity',
  'gene_group': 'circle-opacity',
  'hexa': 'circle-opacity',
  'bg': 'raster-opacity',
  'fic': 'raster-opacity',
  'roi': 'fill-opacity',
}

const CommonControls = ({ layer, layerVisibility, styles }) => {

  const { map } = useContext(MapContext);
  const [rasterOpacity, setRasterOpacity] = useState(styles?.rasterOpacity || 0.85);
  const [fillOpacity, setFillOpacity] = useState(styles?.fillOpacity || 0.8);
  const [circleOpacity, setCircleOpacity] = useState(styles?.circleOpacity || { opacityOnHover: 1, opacity: 0.8 });

  const changeOpacity = (event, newOpacity) => {
    // update opacity according to asset type
    switch (opacityProperty[layer.assetType]) {
      case 'circle-opacity':
        const newOpacityOnHover = newOpacity <= 0.8 ? 1 : 0.5;
        setCircleOpacity({ opacityOnHover: newOpacityOnHover, opacity: newOpacity });
        break;
      case 'raster-opacity':
        setRasterOpacity(newOpacity);
        break;
      case 'fill-opacity':
        setFillOpacity(newOpacity);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    styles?.rasterOpacity && setRasterOpacity(styles.rasterOpacity);
    styles?.circleOpacity && setCircleOpacity(styles.circleOpacity);
    styles?.fillOpacity && setFillOpacity(styles.fillOpacity);
  }, [styles]);

  useEffect(() => {
    // update opacity from layer according to asset type
    switch (opacityProperty[layer.assetType]) {
      case 'circle-opacity':
        if (layer.assetType === "gene_group") {
          layer.subLayerIds.map(layerId => map.current.setPaintProperty(layerId, opacityProperty[layer.assetType], [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            circleOpacity.opacityOnHover,
            circleOpacity.opacity
          ]));
        } else {
          map.current.setPaintProperty(layer.id, opacityProperty[layer.assetType], [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            circleOpacity.opacityOnHover,
            circleOpacity.opacity
          ]);
        }
        break;
      case 'raster-opacity':
        map.current.setPaintProperty(layer.id, opacityProperty[layer.assetType], rasterOpacity);
        break;
      case 'fill-opacity':
        map.current.setPaintProperty(layer.id, opacityProperty[layer.assetType], fillOpacity);
        break;
      default:
        break;
    }
  }, [rasterOpacity, circleOpacity, fillOpacity]);

  return (
    <div>
      <div className='layerPanelControl'>
        <span>Opacity:</span>
        <Slider
          value={["gene", "gene_group", "hexa"].includes(layer.assetType) ? circleOpacity.opacity : ["bg", "fic"].includes(layer.assetType) ? rasterOpacity : fillOpacity}
          step={0.1}
          min={0}
          max={1}
          valueLabelDisplay="auto"
          onChange={changeOpacity}
          disabled={!layerVisibility}
        />
      </div>
    </div>
  );
}
export default CommonControls
